/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ChangePassword200Response
 */
export interface ChangePassword200Response {
  /**
   *
   * @type {boolean}
   * @memberof ChangePassword200Response
   */
  status: boolean
  /**
   *
   * @type {string}
   * @memberof ChangePassword200Response
   */
  message: string
}

/**
 * Check if a given object implements the ChangePassword200Response interface.
 */
export function instanceOfChangePassword200Response(
  value: object
): value is ChangePassword200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('message' in value) || value['message'] === undefined) return false
  return true
}

export function ChangePassword200ResponseFromJSON(
  json: any
): ChangePassword200Response {
  return ChangePassword200ResponseFromJSONTyped(json, false)
}

export function ChangePassword200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ChangePassword200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    message: json['message'],
  }
}

export function ChangePassword200ResponseToJSON(
  value?: ChangePassword200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    message: value['message'],
  }
}
